import React from "react";
import { Link, graphql } from "gatsby";
import styled from "styled-components";
import Layout from "../components/layout";
import SEO from "../components/seo";
// import "../styles/meyer-reset.css";
import "../fonts/fonts.css";
import "../styles/main.css";
import Spacing from "../components/Spacing";
import PostDate from "../components/PostDate";

const Description = styled.p`
  margin-top: -0.8em;
  color: rgba(0, 0, 0, 0.54);

  text-decoration: none;
`;

const WelcomeP = styled.p`
  padding: 0 4em;
  text-align: center;
`;

const IndexPage = ({ data }) => {
  return (
    <Layout>
      <SEO title="Home" />
      <WelcomeP>
        Hi <br />
        I'm Nathan Vogel
        <br /> an interaction designer + developer
        <br /> based in Geneva, Switzerland
        <br /> and this is my blog.
        <br />
        <br /> You might find posts on wildly different topics.
        <br /> But they'll probably have to do with technology.
      </WelcomeP>
      <Spacing height={2} />
      {/* <h3>Posts</h3> */}
      {data.allMarkdownRemark.edges.map(({ node }) => (
        <div key={node.id}>
          <Link to={node.fields.slug}>
            <h2>{node.frontmatter.title}</h2>
            <Description>
              <PostDate date={node.frontmatter.date} /> ·{" "}
              {node.frontmatter.teaser}
            </Description>
          </Link>
          <Spacing height={1} />
        </div>
      ))}
    </Layout>
  );
};

export const query = graphql`
  query {
    allMarkdownRemark(sort: { fields: [frontmatter___date], order: DESC }) {
      totalCount
      edges {
        node {
          id
          frontmatter {
            title
            date(formatString: "YYYY-MM-DD")
            teaser
          }
          fields {
            slug
          }
          excerpt
        }
      }
    }
  }
`;

export default IndexPage;
